angular.module('pitch.app').controller('NewsArticleCtrl',
    function($scope, article, $sce, SiteContext, ContentsLoader) {
        "use strict";
        $scope.article = article;
        $scope.articleBody = $sce.trustAsHtml(article.body);

        var moreIsLoaded = false;

        $scope.loadMore = function() {
            if (moreIsLoaded) {
                return false;
            }

            moreIsLoaded = true;

            SiteContext.get().then(function(r) {
                $scope.newsLoader = new ContentsLoader({
                    sortField: 'date',
                    sortOrder: 'DESC',
                    category: 'news',
                    namespace: '/,sites/' + r.id
                }).onLoad(function(r) {
                    $scope.featuredItems = r;//r.slice(0, 2);
                }).getFirstPage();
            });
        };
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/NewsArticleCtrl.js